import {IQuestionState, QuestionActions} from "./types";
import {Reducer} from "redux";
import {getType} from "typesafe-actions";
import * as actions from "./actions";

export const questionsInitialState: IQuestionState = {
    progress: Object.create(null),
    currentQuestionId: 0,
};

export const questionsReducer: Reducer<IQuestionState, QuestionActions> = (state = questionsInitialState, action) => {
    switch (action.type) {
        case getType(actions.enterQuestion):
            return {
                ...state,
                currentQuestionId: action.payload
            };

        case getType(actions.answerQuestion):
            return {
                ...state,
                progress: {
                    ...state.progress,
                    [action.payload.questionId]: action.payload
                }
            };

        case getType(actions.resetAnswerTimer):
            return {
                ...state,
                progress: {
                    ...state.progress,
                    [action.payload.questionId]: {
                        ...action.payload,
                        attempts: 0,
                    } as any
                }
            };

        case getType(actions.skipQuestion):
        case getType(actions.expireAnswerTimeout):
            return {
                ...state,
                progress: {
                    ...state.progress,
                    [action.payload.questionId]: {
                        ...action.payload,
                        answerId: 0,
                        isRight: false,
                        score: 0,
                        attempts: -1,
                        timestamp: new Date().getTime(),
                        isTimeoutExpired: action.type === getType(actions.expireAnswerTimeout),
                        isSkipped: action.type === getType(actions.skipQuestion),
                    }
                }
            };

        case getType(actions.enterDoubleChanceMode):
            return {
                ...state,
                progress: {
                    ...state.progress,
                    [action.payload]: {
                        ...state.progress[action.payload],
                        attempts: 1
                    }
                }
            };

        case getType(actions.leaveFeedback):
            return {
                ...state,
                progress: {
                    ...state.progress,
                    [action.payload.questionId]: {
                        ...state.progress[action.payload.questionId],
                        feedback: action.payload.feedback,
                    }
                }
            };

        default:
            return state;
    }
};
